<div class="container-fluid" >
  <core-spinner *ngIf="vm.isLoading"></core-spinner>

  <cli-landing-header></cli-landing-header>

  <div class="row">
    <div class="col-xl-2 col-lg-1 "></div>
    <div class="col-xl-2 col-lg-2 col-md-3  pt-4">
      <cli-landing-menu></cli-landing-menu>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-5 d-flex justify-content-center">
      <div style="width:300px;">
        <form>
          <div>
            <div class="mt-2 mb-4 row">
              <div class="col welcome-text text-center">Sign in to Hydrotrak</div>
            </div>
            <div class="row">
              <div class="col mb-2">
                <input class="form-control" [ngClass]="{'is-invalid': !!error('userName')}" name="userName"
                  placeholder="Permit Number" type="email" [(ngModel)]="vm.userName">
                <div class="invalid-feedback">
                  {{error('userName')}}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col mb-2">
                <input class="form-control" [ngClass]="{'is-invalid': !!error('password')}" name="password"
                  placeholder="Password" type="password" [(ngModel)]="vm.password">
                <div class="invalid-feedback">
                  {{error('password')}}
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col d-flex ">
              <div class="form-check">
                <label for="isRememberMe" class="form-check-label"> </label>
                <input style="cursor:pointer;" class="form-check-input" name="isRememberMe" type="checkbox" value="true"
                  id="defaultCheck1" [(ngModel)]="vm.isRememberMe">

                <span>Remember me </span>
              </div>
              <div class="ml-auto"><a routerLink='/forgot-password'>Forgot Password</a></div>
            </div>
          </div>
          <div class="mt-4 mb-2 row">
            <div class="col"></div>
            <div class="col-md-6">
              <button class="btn btn-block btn-primary" (click)="login()">Log in</button>
            </div>
            <div class="col"></div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-3"></div>
    <div class="col-xl-2 col-lg-1 "></div>
  </div>


  <div style="padding-bottom:100px">

  </div>


  <cli-landing-footer></cli-landing-footer>

</div>